import {
    Autocomplete,
    Box,
    Grid,
    TextField } from "../../ui";
import { useState } from "react";
import {
  INITIATED,
  isEmpty,
  TRIP_ASSIGNED,
  TRIP_DELIVERED,
  TRIP_RUNNING
} from "../../../constants/constant";

const DeliveryStatusChange = ({ billData, setBillData }) => {

    const [prevDeliveryStatus] = useState(billData?.tripDetails ?? "");

    const TRIP_STATUS = [
        INITIATED, TRIP_ASSIGNED, TRIP_RUNNING, TRIP_DELIVERED
    ];

    const handleTripStatusChange = (val) => {
        if (isEmpty(val)) {
            setBillData(prev => ({ ...prev, tripDetails: prevDeliveryStatus }));
            return;
        }
        if (prevDeliveryStatus === INITIATED) {
            setBillData(prev => ({ ...prev, tripDetails: val }));
        } else if (prevDeliveryStatus === TRIP_ASSIGNED && val !== INITIATED) {
            setBillData(prev => ({ ...prev, tripDetails: val }));
        } else if (prevDeliveryStatus === TRIP_RUNNING && val === TRIP_DELIVERED) {
            setBillData(prev => ({ ...prev, tripDetails: val }));
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item md={6} xs={12} lg={6} sm={6}>
                <TextField
                    id="delvName"
                    name="delvName"
                    variant="filled"
                    size="small"
                    label="Enter Delivery Name"
                    value={billData?.delvName ?? ""}
                    onChange={(e) => setBillData(prev => ({ ...prev, delvName: e.target.value }))}
                />
            </Grid>
            <Grid item md={6} xs={12} lg={6} sm={6}>
                <TextField
                    id="homeDelvId"
                    name="homeDelvId"
                    variant="filled"
                    size="small"
                    label="Enter Reference Number"
                    value={billData?.homeDelvId ?? ""}
                    onChange={(e) => setBillData(prev => ({ ...prev, homeDelvId: e.target.value }))}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="deliveryInformation"
                    name="deliveryInformation"
                    variant="filled"
                    size="small"
                    fullWidth
                    label="Enter Delivery Link"
                    value={billData?.deliveryInformation ?? ""}
                    onChange={(e) => setBillData(prev => ({ ...prev, deliveryInformation: e.target.value }))}
                />
            </Grid>
            <Grid item xs={12} md={6} sm={6} lg={6}>
                <Autocomplete
                    id="trip-select"
                    options={TRIP_STATUS}
                    autoHighlight
                    variant="filled"
                    disabled={prevDeliveryStatus === TRIP_DELIVERED}
                    size="small"
                    onChange={(_, val) => handleTripStatusChange(val)}
                    style={{ width: "90%", maxHeight: "20%" }}
                    isOptionEqualToValue={(option, value) => option === value}
                    getOptionLabel={(option) => option || ""}
                    value={billData?.tripDetails ?? ""}
                    renderOption={(props, option) => (
                        <Box component="li" {...props}>
                            {option}
                        </Box>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Update Delivery Status"
                            placeholder="Select Delivery Status"
                            inputProps={{ ...params.inputProps }}
                        />
                    )}
                />
            </Grid>
        </Grid>
    )
}

export default DeliveryStatusChange;
